const FontFaceObserver = require('fontfaceobserver');

const fontsData = {
  'Aeonik': { weight: 'normal' }
};

const defaultFonts = [
  'Aeonik'
]

function loadFonts(fonts = defaultFonts) {
  return new Promise((resolve) => {
    const fontFaceObersvers = fonts.map(font => {
      const data = fontsData[font];
      return new FontFaceObserver(font, data);
    })
    Promise.all(fontFaceObersvers).then(() => {
      resolve();
    });
  })
}

export default loadFonts;